<main class="govuk-width-container" *ngIf="showContent" id="main-content" tabindex="-1">
	<div class="govuk-grid-row">
		<div class="govuk-grid-column-full">
			<h1 class="mb-3">
				{{ startPageSubtitle }}
			</h1>

			<div [innerHTML]="startPageSubtitleBody"></div>

			<div class="button-container">
				<button class="btn btn-primary" (click)="startBooking()">
					Book your ceremony
				</button>
			</div>
		</div>
	</div>
</main>
